(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('ustyle-selector-vistas')) {
    customElements.define(
      'ustyle-selector-vistas',
      class extends HTMLElement {
        connectedCallback() {
          if (this._controlador) return;

          const catalogo = this.closest('[data-us-catalogo]');
          if (!catalogo) return;

          this._controlador = new AbortController();
          const signal = this._controlador.signal;
          const clave = 'ustyle-vista-colecciones';
          let vista = 'grande';

          try {
            const guardada = sessionStorage.getItem(clave);
            if (guardada === 'lista' || guardada === 'grande') {
              vista = guardada;
            }
          } catch (error) {
            /* El selector funciona aunque no se permita guardar preferencias. */
          }

          const aplicar = () => {
            catalogo.dataset.usVista = vista;

            this.querySelectorAll('[data-vista]').forEach((boton) => {
              boton.setAttribute(
                'aria-pressed',
                String(boton.dataset.vista === vista)
              );
            });

            /*
             * Mantiene visibles los datos de las tarjetas cuando el tema
             * conserva una presentación de miniaturas de una visita anterior.
             */
            catalogo.querySelectorAll('.product-grid').forEach((rejilla) => {
              if (rejilla.getAttribute('product-grid-view') !== 'default') {
                rejilla.setAttribute('product-grid-view', 'default');
              }
            });
          };

          this.addEventListener(
            'click',
            (evento) => {
              const boton = evento.target.closest('button[data-vista]');
              if (!boton || !this.contains(boton)) return;

              const seleccion = boton.dataset.vista;
              if (seleccion !== 'lista' && seleccion !== 'grande') return;

              vista = seleccion;

              try {
                sessionStorage.setItem(clave, vista);
              } catch (error) {
                /* La preferencia sigue activa durante esta página. */
              }

              aplicar();
            },
            { signal }
          );

          /*
           * Reaplica la presentación al filtrar, ordenar
           * o cargar más productos.
           */
          let pendiente = false;

          this._observador = new MutationObserver(() => {
            if (pendiente) return;
            pendiente = true;

            requestAnimationFrame(() => {
              pendiente = false;
              if (this.isConnected) aplicar();
            });
          });

          this._observador.observe(catalogo, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['product-grid-view']
          });

          aplicar();
        }

        disconnectedCallback() {
          this._observador?.disconnect();
          this._controlador?.abort();
          this._controlador = null;
        }
      }
    );
  }

  const urlColeccion = new URL(window.location.href);

  if (urlColeccion.hash) {
    const desplazarHastaProducto = () => {
      const tarjeta = document.getElementById(
        urlColeccion.hash.slice(1)
      );

      if (tarjeta) {
        tarjeta.scrollIntoView({ behavior: 'instant' });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        desplazarHastaProducto,
        { once: true }
      );
    } else {
      desplazarHastaProducto();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
